module.exports = "<svg viewBox=\"0 0 16.1 16.1\"><path fill=\"#231F20\" d=\"M8.1 16.1H1c-.6 0-1-.4-1-1v-7c0-.6.4-1 1-1h7.1c.6 0 1 .4 1 1v7.1c0 .5-.5.9-1 .9zm-6.1-2h5.1v-5H2v5z\"></path><path fill=\"#231F20\" d=\"M15.1 12.6h-3.6c-.6 0-1-.4-1-1s.4-1 1-1h2.6V2H5.5v2.6c0 .6-.4 1-1 1s-1-.4-1-1V1c0-.6.4-1 1-1h10.6c.6 0 1 .4 1 1v10.6c0 .5-.4 1-1 1z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/open-external.svg
// module id = 310
// module chunks = 1